import { useState } from 'react';

import { CommonQueryParams } from '@/services/vehicleDiagnosticsApi';
import { usePagination } from './usePagination';
import { useSorting } from './useSorting';

const COMMON_ALLOWED_SORT_BY = ['vehicle', 'vin', 'customer', 'workshop'] as const;

export type CommonSortBy = (typeof COMMON_ALLOWED_SORT_BY)[number];

export const useCommonQueryParams = <T = CommonSortBy>({
    pageSize = 20,
    pageNumber = 0,
    sortBy = COMMON_ALLOWED_SORT_BY[0] as T,
    sortDirection = 'ASC',
    accountIds,
    workshopIds,
    assetIds,
}: CommonQueryParams<T>) => {
    const pagination = usePagination(pageNumber, pageSize);
    const sorting = useSorting<T>(sortBy, sortDirection);
    const [assetIdsState, setAssetIdsState] = useState<string[] | undefined | null>(assetIds);
    const [workshopIdsState, setWorkshopIdsState] = useState<string[] | undefined | null>(workshopIds);
    const [accountIdsState, setAccountIdsState] = useState<string[] | undefined | null>(accountIds);

    return {
        pagination,
        sorting,
        assetIds: assetIdsState,
        setAssetIds: setAssetIdsState,
        workshopIds: workshopIdsState,
        setWorkshopIds: setWorkshopIdsState,
        accountIds: accountIdsState,
        setAccountIds: setAccountIdsState,
    };
};
